import React from "react";
import {CardBody, CardText, CardTitle} from "reactstrap";
import Toggle from "react-toggle";
import {useDispatch, useSelector} from "react-redux";
import {saveSelectedCustomer} from "../../../redux/Actions/customers.actions";
import {getCurrentCustomer} from "../../../redux/Selectors/customers.selectors";

const CustomerCard = ({data}) => {
  const {id = "", name = ""} = data;
  const dispatch = useDispatch();
  const currentCustomer = useSelector(getCurrentCustomer);

  const switchCurrentCustomer = () => {
    dispatch(saveSelectedCustomer(data));
  };

  return (
    <CardBody>
      <CardTitle tag="h3">{name}</CardTitle>
      <CardText>
        <div style={{marginBottom: "5%"}}>
          <Toggle
            checked={currentCustomer && id === currentCustomer.id}
            name={"switch_customer"}
            data-cy={"switch_customer"}
            value={currentCustomer && id !== currentCustomer.id}
            onChange={switchCurrentCustomer}
          />
        </div>
      </CardText>
    </CardBody>
  );
};

export default CustomerCard;
